import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { ActionButton } from './ActionButton';

interface BalanceButtonsProps {
    onTopUp: () => void;
    onWithdraw: () => void;
}

export const BalanceButtons: React.FC<BalanceButtonsProps> = ({
    onTopUp,
    onWithdraw
}) => {
    return (
        <Container>
            <ActionButton onClick={onTopUp} variant="secondary">
                <FormattedMessage
                    id="Finance.TopUp.Button"
                    defaultMessage="Top Up Balance"
                />
            </ActionButton>
            <ActionButton onClick={onWithdraw}>
                <FormattedMessage
                    id="Finance.Withdraw.Button"
                    defaultMessage="Withdraw Funds"
                />
            </ActionButton>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    gap: 5px;
    height: 32px;
    
    button {
        width: 130px;
    }

    @media (max-width: 768px) {
        justify-content: space-between;
        width: 100%;
        gap: 8px;

        button {
            width: 100%;
            border-radius: 8px;
        }
    }
`;
